// src/components/Modal.jsx
import React, { useEffect } from "react";

export default function Modal({ open, onClose, title, children }) {
  // Always call hooks; guard inside the effect
  useEffect(() => {
    if (!open) return;

    const onKey = (e) => {
      if (e.key === "Escape") onClose?.();
    };
    document.addEventListener("keydown", onKey);
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = prevOverflow;
    };
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-50 grid place-items-center bg-black/60 p-4"
      role="dialog"
      aria-modal="true"
      aria-labelledby="modal-title"
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose?.();
      }}
    >
      <div className="card-solid max-w-3xl w-full max-h-[85vh] overflow-y-auto">
        <header className="flex items-center justify-between gap-4">
          <h2 id="modal-title" className="text-xl font-semibold text-white">
            {title}
          </h2>
          <button
            onClick={onClose}
            className="btn-secondary"
            aria-label="Close"
          >
            Close
          </button>
        </header>
        <div className="prose prose-invert mt-4">{children}</div>
      </div>
    </div>
  );
}
